module.exports = __webpack_public_path__ + "img/founderx4.a33bbfc4.jpeg";